import * as Yup from 'yup';

export default Yup.object({
  doorNumber: Yup.string().required('Required')
});
